import { render, staticRenderFns } from "./ListaDistribucionForm.vue?vue&type=template&id=9ec42b2e&scoped=true&"
import script from "./ListaDistribucionForm.vue?vue&type=script&lang=ts&"
export * from "./ListaDistribucionForm.vue?vue&type=script&lang=ts&"
import style0 from "./ListaDistribucionForm.vue?vue&type=style&index=0&id=9ec42b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec42b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9ec42b2e', component.options)
    } else {
      api.reload('9ec42b2e', component.options)
    }
    module.hot.accept("./ListaDistribucionForm.vue?vue&type=template&id=9ec42b2e&scoped=true&", function () {
      api.rerender('9ec42b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ListaDistribucion/ListaDistribucionForm.vue"
export default component.exports